import { computed, ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-14fbae34"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wechat-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'WxMinGamePayBaseConfig'
};
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {},
    prodChnl: String // 用来判断渠道字段及分成系数提示
  },
  emits: ['submitForm'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const isShopPay = computed(() => props.prodChnl === 'wxMinGameShopPayBaseConfig');
    const divideList = ref([]); // 分成比例
    const rateList = [{
      label: 1,
      value: '1'
    }, {
      label: 10,
      value: '10'
    }, {
      label: 100,
      value: '100'
    }]; // rate
    const wxMinGameRef = ref(null); // 微信jsApi支付ref
    const wxMinGameForm = reactive({
      divide: '0.6',
      appId: '',
      offerId: '',
      zoneId: '',
      appKey: '',
      envConfig: '0',
      appSecret: '',
      mchId: null,
      apiKeyV3: '',
      mchName: '',
      merchants: '',
      wxPriKey: '',
      rate: '1',
      pkg: ''
    }); // 微信小游戏支付
    const validateForm = () => {
      var _wxMinGameRef$value;
      (_wxMinGameRef$value = wxMinGameRef.value) === null || _wxMinGameRef$value === void 0 || _wxMinGameRef$value.validate().then(() => {
        emit('submitForm', wxMinGameForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        wxMinGameForm.pkg = n.pkg;
        wxMinGameForm.appId = n.appId;
        wxMinGameForm.zoneId = n.zoneId;
        wxMinGameForm.offerId = n.offerId;
        wxMinGameForm.appKey = n.appKey;
        wxMinGameForm.appSecret = n.appSecret;
        wxMinGameForm.envConfig = n.envConfig || '0';
        wxMinGameForm.mchId = n.mchId;
        wxMinGameForm.apiKeyV3 = n.apiKeyV3;
        wxMinGameForm.mchName = n.mchName;
        wxMinGameForm.merchants = n.merchants;
        wxMinGameForm.wxPriKey = n.wxPriKey;
        wxMinGameForm.divide = n.divide;
        wxMinGameForm.rate = n.rate;
        divideList.value = n.divideList;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: wxMinGameForm,
        ref_key: "wxMinGameRef",
        ref: wxMinGameRef,
        rules: __props.rules,
        name: "wxMinGame-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wxMinGameForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => wxMinGameForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: wxMinGameForm.divide,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => wxMinGameForm.divide = $event),
            options: divideList.value
          }, null, 8, ["value", "options"]), props.prodChnl === 'wxMinGamePayBaseConfig' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("普通小游戏获得月流水60%分成，创意小游戏获得月流水70%分成%，填写前请确认")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })) : _createCommentVNode("", true)])]),
          _: 1
        }), !_unref(isShopPay) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0,
          name: "envConfig",
          label: "环境配置："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio, {
            checked: ""
          }, {
            default: _withCtx(() => [_createTextVNode("现网环境")]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), !_unref(isShopPay) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 1,
          name: "zoneId",
          label: "Zone_ID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wxMinGameForm.zoneId,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => wxMinGameForm.zoneId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), !_unref(isShopPay) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 2,
          name: "offerId",
          label: "OfferID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wxMinGameForm.offerId,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => wxMinGameForm.offerId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), !_unref(isShopPay) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 3,
          name: "appId",
          label: "AppID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wxMinGameForm.appId,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => wxMinGameForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
          name: "appKey",
          label: "AppKey："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wxMinGameForm.appKey,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => wxMinGameForm.appKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), !_unref(isShopPay) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 4,
          name: "rate",
          label: "Rate："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: wxMinGameForm.rate,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => wxMinGameForm.rate = $event),
            valueModifiers: {
              trim: true
            },
            options: rateList,
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), !_unref(isShopPay) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 5,
          name: "appSecret",
          label: "App_secret："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wxMinGameForm.appSecret,
            "onUpdate:value": _cache[7] || (_cache[7] = $event => wxMinGameForm.appSecret = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
          name: "mchName",
          label: "商户主体："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wxMinGameForm.mchName,
            "onUpdate:value": _cache[8] || (_cache[8] = $event => wxMinGameForm.mchName = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "merchants",
          label: "商户号："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: wxMinGameForm.merchants,
            "onUpdate:value": _cache[9] || (_cache[9] = $event => wxMinGameForm.merchants = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "apiKeyV3",
          label: "API key V3："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wxMinGameForm.apiKeyV3,
            "onUpdate:value": _cache[10] || (_cache[10] = $event => wxMinGameForm.apiKeyV3 = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "wxPriKey",
          label: "wx_pri_key："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: wxMinGameForm.wxPriKey,
            "onUpdate:value": _cache[11] || (_cache[11] = $event => wxMinGameForm.wxPriKey = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});